import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchCaseStudyById,
  fetchCaseStudyIdAltRange
} from './../../_redux/actions/CaseStudyActions';
import { DefaultHeader, CaseStudyDetailSlider } from './../parts/Parts';
import { motion } from "framer-motion";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CaseStudyDetailSkeleton = () => (
  <div className="component case-study-detail-component">
    <div className="row case-study-detail-component-one">
      <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <div className="case-study-detail-logo-container">
          <div className="skeleton-block skeleton-detail-logo" />
        </div>
      </div>
      <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
        <div className="skeleton-block skeleton-range" style={{ marginBottom: '1.25em' }} />
        <div className="skeleton-tags">
          <div className="skeleton-block skeleton-tag" />
          <div className="skeleton-block skeleton-tag" />
          <div className="skeleton-block skeleton-tag" />
        </div>
        <div className="skeleton-block skeleton-text" />
        <div className="skeleton-block skeleton-text" />
        <div className="skeleton-block skeleton-text skeleton-text--short" />
        <div className="skeleton-block skeleton-text" style={{ marginTop: '1.25em' }} />
        <div className="skeleton-block skeleton-text skeleton-text--short" />
      </div>
    </div>
  </div>
);

const CaseStudyDetail = () => {
  const { id } = useParams();
  const cloudfrontURL = process.env.REACT_APP_CLOUDFRONT_URL;
  const dispatch = useDispatch();

  const caseStudy = useSelector((state) => state.caseStudies.caseStudy);
  const loading = useSelector((state) => state.caseStudies.loading);
  const caseStudyIdAltRange = useSelector((state) => state.caseStudies.firstAndLast);

  useEffect(() => {
    dispatch(fetchCaseStudyById(id));
    dispatch(fetchCaseStudyIdAltRange());
  }, [dispatch, id]);

  if (!caseStudy) {
    return (
      <>
        <DefaultHeader defaultHeader="" />
        <CaseStudyDetailSkeleton />
      </>
    );
  }

  const heading = caseStudy.case_study_title || caseStudy.case_study_name || '';

  return (
    <>
      <DefaultHeader defaultHeader={heading} />

      <motion.div
        className="component case-study-detail-component"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="row case-study-detail-component-one">
          <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <motion.div
              className="case-study-detail-logo-container"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.75 }}
            >
              <img
                className="case-study-detail-logo"
                src={cloudfrontURL + caseStudy.case_study_logo}
                alt={`${heading} Logo`}
              />
            </motion.div>
          </div>

          <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
            {caseStudy.case_study_id_alt ? (
              <p className="case_study_id_alt_range">
                {caseStudy.case_study_id_alt} - {caseStudyIdAltRange?.last || ""}
              </p>
            ) : null}

            {caseStudy.case_study_tags && caseStudy.case_study_tags.length > 0 ? (
              <div className="case-study-tags-container">
                {caseStudy.case_study_tags.map((tag, index) => (
                  <span key={index} className="case-study-tag">
                    {tag}
                  </span>
                ))}
              </div>
            ) : null}

            {caseStudy.case_study_description &&
              caseStudy.case_study_description.map((description, index) =>
                description ? (
                  <p key={index} className="case_study_description">
                    {description}
                  </p>
                ) : null
              )}
          </div>
        </div>
      </motion.div>

      <CaseStudyDetailSlider />
    </>
  );
};

export default CaseStudyDetail;
